import officerApi from '../services/api/officerApi';
import officerInviteApi from '../services/api/officerInviteApi';
import { setAlert } from './alerts';

export const INVITES_REFRESHED = 'SETTINGS/INVITES_REFRESHED';
export const OFFICERS_REFRESHED = 'SETTINGS/OFFICERS_REFRESHED';
export const ROLES_REFRESHED = 'SETTINGS/ROLES_REFRESHED';
export const OFFICER_INVITES_REFRESHED = 'SETTINGS/OFFICER_INVITES_REFRESHED';

export const invitesRefreshed = (invites) => ({
    type: INVITES_REFRESHED,
    invites,
});

export const officersRefreshed = (officers) => ({
    type: OFFICERS_REFRESHED,
    officers,
});

export const officerInvitesRefreshed = (officerInvites) => ({
    type: OFFICER_INVITES_REFRESHED,
    officerInvites,
});

export const rolesRefreshed = (roles) => ({ type: ROLES_REFRESHED, roles });

export const getAllOfficers = () => async (dispatch) => {
    try {
        const {
            data: { data },
        } = await officerApi.getAll();
        dispatch(officersRefreshed(data));
    } catch ({ response }) {
        dispatch(setAlert('Unable to fetch officers.', 'error'));
    }
};

export const getAllOfficerRoles = () => async (dispatch) => {
    try {
        const {
            data: { data },
        } = await officerApi.getAllRoles();
        dispatch(rolesRefreshed(data));
    } catch ({ response }) {
        dispatch(setAlert('Unable to fetch officer roles.', 'error'));
    }
};

export const getAllOfficerInvites = () => async (dispatch) => {
    try {
        const {
            data: { data },
        } = await officerInviteApi.getAll();
        dispatch(officerInvitesRefreshed(data));
    } catch ({ response }) {
        dispatch(setAlert('Unable to fetch officer invites.', 'error'));
    }
};
